/**
 * Resolve a human-readable segment label from API fields and/or segment option list.
 */
export function resolveSegmentLabel(segmentId, segmentsList, explicitName) {
  const candidates = [
    explicitName,
    explicitName?.label,
    explicitName?.name,
  ].filter((v) => v != null && String(v).trim() !== "");

  for (const raw of candidates) {
    const text = String(raw).trim();
    if (!/^\d+$/.test(text)) return text;
  }

  const id =
    segmentId != null && segmentId !== ""
      ? Number(segmentId)
      : candidates.length
        ? Number(candidates[0])
        : NaN;

  if (Number.isFinite(id)) {
    const seg = (segmentsList || []).find(
      (s) => Number(s.value ?? s.id ?? s.segmentId) === id
    );
    if (seg?.label) return seg.label;
    if (seg?.name) return seg.name;
  }

  if (candidates.length) return String(candidates[0]).trim();
  return "—";
}
